module.exports = __webpack_public_path__ + "media/images/people/girl-1-4dae75abc4ccff872166229835175bef.webp";